/**
 * Represent the existing Groups in Auth0
 * that can be used in the System
 */
export class Groups {
  static ADMIN_PORTAL = 'Admin Portal';
  static ASSET_ADMINISTRATOR = 'Asset Administrator';
  static ASSET_VIEWER = 'Asset Viewer';
  static ASSET_MANAGER = 'Asset Manager';
  static CLIENT_ADMIN = 'Client Administrator';
  static USER_ADMIN = 'User Management Administrator';
  static ENTERPRISE_SP_USER_MANAGER =
    'Enterprise Service Provider User Manager';
  static SPM_USER_MANAGER = 'SPM User Manager';
  static CUSTOMER_USER_MANAGER = 'Customer User Manager';
  static PRODUCT_ADMIN = 'Product Administrator';
  static SUPPORT_USER = 'Support User';
  static FORMS_ADMINISTRATOR = 'Forms Administrator';
}
